export default [
  // 资讯详情
  {
    path: '/information-detail-:id',
    component: () => import('@/views/social/information/Detail.vue'),
    name: 'information-detail',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 门店详情
  {
    path: '/information-store-detail-:id',
    component: () => import('@/views/social/information/StoreDetail.vue'),
    name: 'information-store-detail',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-two-gray',
    },
  },
  // 帖子
  {
    path: '/social-post-detail-:id',
    component: () => import('@/views/social/post/detail/Index.vue'),
    name: 'social-post-detail',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 举报
  {
    path: '/social-report-create-:reportedType-:reportedId',
    component: () => import('@/views/social/report/Create.vue'),
    name: 'social-report-create',
    meta: {
      auth: 1,
      visibleShare: true,
      backgroundClass: 'bg-two-gray',
    },
  },
];
